import { render, staticRenderFns } from "./MyAccountRedirect.vue?vue&type=template&id=75bed312"
import script from "./MyAccountRedirect.vue?vue&type=script&lang=js"
export * from "./MyAccountRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75bed312')) {
      api.createRecord('75bed312', component.options)
    } else {
      api.reload('75bed312', component.options)
    }
    module.hot.accept("./MyAccountRedirect.vue?vue&type=template&id=75bed312", function () {
      api.rerender('75bed312', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/people/professional/MyAccountRedirect.vue"
export default component.exports